<template>
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye-outline</v-icon>
            Visualizar Notificação
          </div>
        </v-toolbar>
        <div class="container dialog mt-7" >
          <v-form ref="form" v-if="visible">
            <v-row>
                <v-col cols="6">
                    <v-text-field
                    v-model="content.assunto"
                    label="Assunto da Notificação"
                    dense
                    outlined
                    disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                    v-model="content.notificacao"
                    label="Notificação"
                    rows="3"
                    dense
                    outlined
                    disabled
                    ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <span class="small">Grupo(s)</span>
                  <div class="grupos-box">
                    <v-chip-group active-class="primary--text" column>
                      <v-chip v-for="grupo in content.grupos" :key="grupo.id">
                        {{ grupo.nome }}
                      </v-chip>
                    </v-chip-group>
                  </div>
              </v-col>
            </v-row>
          </v-form>
        </div>
       <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { GrupoNotificacao } from '~/commons/classes/grupo-notificacao';

export default {
  props: new DialogProps(GrupoNotificacao),
}
</script>

 <style scoped>
  .grupos-box {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-top: 10px;
  }
  </style>